import React, { useEffect } from "react";
import { useRef, useState, useContext } from "react";
import { Form, Button, Row, Col, Table } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { AuthContext } from "../../utility/AuthContext";
import { io } from "socket.io-client";

function WaitingSearch({ setLoader, setSearch, setId, setName }) {
  const formRef = useRef();
  const [patientList, setPatientList] = useState([]);
  const { user } = useContext(AuthContext);
  const socket = io(API_BASE_URL);

  useEffect(() => {
    socket.on("waiting-patient-list", (data) =>
      setPatientList(data.patient_list)
    );
    socket.emit("waiting-patient-list", user.name);
    return () => socket.off("waiting-patient-list");
  }, [user]);

  return (
    <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container bg-white p-4 rounded shadow-sm">
        <h5 className="mb-3">Waiting Patients</h5>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th style={{ width: "100px" }}>Action</th>
              <th>Name</th>
              <th>Time</th>
              <th>Fees</th>
              <th>Last Payment Date</th>
            </tr>
          </thead>
          <tbody>
            {patientList.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center">
                  No records found
                </td>
              </tr>
            ) : (
              patientList.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="info"
                      onClick={() => {
                        setSearch(false);
                        setId(item.id);
                        setName(item.name);
                      }}
                    >
                      VIEW
                    </Button>
                  </td>
                  <td>{item.name}</td>
                  <td>{new Date(item.time).toUTCString().split(" ")[4]}</td>
                  <td>{item.fees}</td>
                  <td>{item.last_visit.split(" ")[0]}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default WaitingSearch;
